<template>
  <value-container v-if="view_only" :value="value" :label="label" :md="md"/>
  <component v-else :is='c_tag' :md3="md==3" :md4="md==4" style="border-bottom: solid 1px lightgrey;padding-bottom:20px">
    <fs1 tag="b">{{label}}</fs1>
    <label :for="`file-upload-st-${id}`" class="custom-file-upload2" style="text-align: right;" :class="dark_t?'dark':''">
      <fs1-span>{{['Cargar', 'Cargando', 'Cargado'][fileStatus]}} </fs1-span>
      <v-icon small>{{['attach_file', 'hourglass_empty', 'check'][fileStatus]}}</v-icon>
      <input :id="`file-upload-st-${id}`" class="btn" type="file" @change="selectFile($event.target.files)">
    </label>
  </component>
</template>

<script>
import {v4 as uuid} from 'uuid';
import inputs from '../mixins/inputs/inputs.js';
export default {
	mixins:[inputs],
  props: ['value'],
  data() {
    return {
      id: uuid(),
      status: 0,
    }
  },
  computed:{
    fileStatus() { return this.value ? (typeof this.value === 'string' ? 2 : this.status) : this.status },
  },
  methods:{
    changeStatus(i){ this.status = i},
    selectFile(files) { // files no es un array por lo que sus proto funciones no aplican
      const file = files[0];
      const {changeStatus} = this;
      changeStatus(1);
      this.$emit('update:value', file);
      const reader = new FileReader();
      reader.onload = e => changeStatus(2);
      reader.readAsDataURL(file);
    }, // selectFile
  }
};
</script>
